import React from 'react';
import './index.css';

export const PageLoading = () => (
  <div className="loading-container">
    <div className="first-indicator" />
    <div className="second-indicator" />
  </div>
);

export default PageLoading;



// WEBPACK FOOTER //
// ./src/components/PageLoading/index.js